(function() {
  'use strict';

  angular
    .module('inspinia', [
      'lbServices',
      'ngAnimate',
      'ngAria',
      'ngCookies',
      'ngMessages',
      'ngResource',
      'ngSanitize',
      'ngSlimScroll',
      'ngStorage',
      'ngTouch',
      'ui.bootstrap',
      'ui.router'
    ]);
})();

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider.state('landing.products.product', {
      url: "/producto/:nombre",
      views: {
        products: {
          templateUrl: "app/landing/products/product/product.html"
        }
      },
      data: {
        pageTitle: 'Products Product'
      }
    });
  })
  .controller('ProductsProductController', function($rootScope, $window, $state, $stateParams, Category, Product) {

    var vm = this;

    function init() {
      scrollWin();
      getContent();
    }

    init();

    function scrollWin() {
      $window.scrollTo(0, 0);
    }

    function getContent() {
      vm.product = Product.findOne({
        filter: {
          where: {
            urlName: $stateParams.nombre
          }
        }
      }, function(product) {
        console.log(product);

        vm.suggestedProducts = Product.find({
          filter: {
            where: {
              id: {
                inq: product.suggestedProducts
              }
            }
          }
        }, function(suggestedProducts) {
          console.log(suggestedProducts);
        });
      });
    }

    vm.selectItem = function(index) {
      console.log(vm.product.units[index])
      vm.product.bannerUrl=vm.product.units[index].imageUrl;
      vm.unitSelected = {
        name: vm.product.units[index].name,
        weight: vm.product.units[index].weight,
        cost: vm.product.units[index].cost,
        imageUrl: vm.product.units[index].imageUrl,

        index: index
      };
      console.log(vm.product)
      var indexCart = $rootScope.cart.items.findIndex(function(item) {
        return item.id == vm.product.id && item.presentation.index == index;
      });

      if (indexCart >= 0) {
        vm.unitSelected.quantity = JSON.parse(JSON.stringify($rootScope.cart.items[indexCart].presentation.quantity));
      } else {
        vm.unitSelected.quantity = 1;
      }
    };

    vm.addToCart = function() {
      console.log("sdsadsa");
      var index = $rootScope.cart.items.findIndex(function(item) {
        return item.id == vm.product.id && item.presentation.index == vm.unitSelected.index;
      });

      if (index >= 0) {
        $rootScope.cart.items[index].presentation = JSON.parse(JSON.stringify(vm.unitSelected));

        $rootScope.calculateCart();
      } else {
        $rootScope.cart.items.push({
          id: vm.product.id,
          isProduct: true,
          presentation: JSON.parse(JSON.stringify(vm.unitSelected))
        });

        $rootScope.calculateCart();
      }
    };

  });

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider.state('landing.products.all', {
      url: "/?categoria",
      views: {
        products: {
          templateUrl: "app/landing/products/all/all.html"
        }
      },
      data: {
        pageTitle: 'Products All'
      }
    });
  })
  .controller('ProductsAllController', function($window, $state, $stateParams, Category, Product) {

    var vm = this;

    function init() {
      scrollWin();
      getContent();
    }

    init();

    function scrollWin() {
      $window.scrollTo(0, 0);
    }

    function getContent() {
      if ($stateParams.categoria) {
        vm.infoCategory = Category.findOne({
          filter: {
            where: {
              urlName: $stateParams.categoria
            }
          }
        }, function(category) {
          vm.infoCategory = category;

          vm.products = Product.find({
            filter: {
              where: {
                isActive: true,
                categoryId: category.id
              }
            }
          }, function() {
            initializeSclick();
          });
        });
      } else {
        Category.findOne({
          filter: {
            where: {
              isActive: true,
              type: "product"
            }
          }
        }, function(category) {
          vm.infoCategory = category;

          vm.products = Product.find({
            filter: {
              where: {
                isActive: true,
                categoryId: category.id
              }
            }
          }, function() {
            initializeSclick();
          });
        });
      }
    }

    function initializeSclick() {
      $(document).ready(function() {
        $('.products-slick').slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          // autoplay: true,
          autoplaySpeed: 5000,
          responsive: [{
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 426,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      });
    }

  });

"use strict";

angular
  .module("inspinia")
  .config(function ($stateProvider) {
    $stateProvider.state("landing.shopping.checkout", {
      url: "/checkout",
      views: {
        shopping: {
          templateUrl: "app/landing/shopping/checkout/checkout.html",
        },
      },
      data: {
        pageTitle: "Shopping Checkout",
      },
    });
  })
  .controller(
    "ShoppingCheckoutController",
    function (
      $localStorage,
      $rootScope,
      $window,
      $state,
      Sale,
      HomeConfig,
      BillingData
    ) {
      var vm = this;

      function init() {
        scrollWin();
        getContent();
      }

      init();

      function scrollWin() {
        $window.scrollTo(0, 0);
      }
      HomeConfig.findOne(
        {},
        function (home) {
          vm.home = home;
          vm.shipmentOptions = home.shipmentOptions;
          if (!vm.shipmentOptions.country.cost) {
            vm.shipmentOptions.country.cost = 320;
          }
       
        },
        function (err) {
          $log.log(err);
        }
      );

      function getContent() {
        Sale.getItemsInfo(
          {
            cart: $rootScope.cart,
          },
          function (resp) {
            console.log(resp.response);

            if (resp.response.success) {
              resp.response.verifiedCart.client = {
                address: {},
              };

              $localStorage.cart = $rootScope.cart = resp.response.verifiedCart;

              if (
                $rootScope.cart.productIds.length &&
                $rootScope.cart.serviceIds.length
              ) {
                vm.clientFormTitle =
                  "Información de envío y datos de beneficiario";
              } else if ($rootScope.cart.productIds.length) {
                vm.clientFormTitle = "Información de envío";
              } else if ($rootScope.cart.serviceIds.length) {
                vm.clientFormTitle = "Datos de beneficiario";
              }

              if (resp.response.hasChanged) {
                $window.swal(
                  "¡Atencion!",
                  "Algunos articulos de tu carrito han cambiado",
                  "warning"
                );
              }
            }
          }
        );
      }

      vm.validateClientInfo = function () {
        if (vm.copyClientInfo) {
          vm.billingData = {
            fullName: $rootScope.cart.client.fullName,
            phone: $rootScope.cart.client.phone,
            email: $rootScope.cart.client.email,
            country: $rootScope.cart.client.address.country,
            city: $rootScope.cart.client.address.city,
            state: $rootScope.cart.client.address.state,
            address: $rootScope.cart.client.address.street,
            colony: $rootScope.cart.client.address.colony,
            zipCode: $rootScope.cart.client.address.zipCode,
          };
        } else {
          vm.billingData = {};
        }
      };

      vm.selectPayment = function (item) {
        if (item != $rootScope.cart.paymentType) {
          $rootScope.cart.paymentType = item;
        } else {
          delete $rootScope.cart.paymentType;
        }
      };

      vm.updateDeliveryBillAmount = function (data) {
        console.log(data);
        vm.deliveryOptions = data;
        if (data) {
          if (
            $rootScope.cart.totalBalance > data.minimumPurchase &&
            data.active
          ) {
            vm.temporalDeliveryAmount = 0;
          } else {
            vm.temporalDeliveryAmount = data.cost;
          }
        } else {
          vm.temporalDeliveryAmount = 0;
        }

  
      };

      vm.confirmSale = function () {
        if (
          $rootScope.cart.deliveryType == "validate" ||
          $rootScope.cart.serviceIds.length
        ) {
          var message = "";

          if ($rootScope.cart.deliveryType == "validate") {
            message =
              "El envío sin costo está sujeto a validación del domicilio ingresado";
          }

          if (
            $rootScope.cart.deliveryType == "validate" &&
            $rootScope.cart.serviceIds.length
          ) {
            message = message.concat(", tambien e");
          }

          if ($rootScope.cart.serviceIds.length) {
            if ($rootScope.cart.deliveryType != "validate") {
              message = message.concat("E");
            }

            message = message.concat(
              "s necesario que te comuniques a la sucursal para agendar la fecha y hora de tu servicio."
            );
          } else {
            message = message.concat(".");
          }

          $window.swal(
            {
              title: "¡Atencion!",
              text: message,
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#219CEA",
              confirmButtonText: "Continuar",
              cancelButtonText: "Cancelar",
              closeOnConfirm: false,
              closeOnCancel: true,
              showLoaderOnConfirm: true,
            },
            function (isConfirm) {
              if (isConfirm) {
                createSale();
              }
            }
          );
        } else {
          createSale();
        }
      };

      function createSale() {
      

        if ($rootScope.cart.paymentType == "card") {
          Conekta.Token.create(
            {
              card: {
                number: vm.cardData.number,
                name: vm.cardData.name,
                exp_year: vm.cardData.exp_year,
                exp_month: vm.cardData.exp_month,
                cvc: vm.cardData.cvc,
              },
            },
            function (token) {
              // console.log(token);
              $rootScope.cart.conektaToken = token.id;
              $rootScope.cart.purchaseDate = new Date();
              $rootScope.cart.deliveryPrice = vm.temporalDeliveryAmount;
              console.log($rootScope.deliveryPrice);

              Sale.createSale(
                {
                  cart: $rootScope.cart,
                },
                function (resp) {
                  console.log(resp);
                 console.log($rootScope.cart);

                  if (resp.response.success) {
                    if ($rootScope.cart.billRequired && vm.billingData) {
                      vm.billingData.saleId = resp.response.id;

                      BillingData.create(
                        vm.billingData,
                        function (success) {
                          $localStorage.cart = $rootScope.cart = {
                            totalBalance: 0,
                            totalPrice: 0,
                            couponDiscount: 0,
                            coupon: {},
                            items: [],
                            productIds: [],
                            serviceIds: [],
                          };

                          vm.cardData = {};
                          vm.billingData = {};

                          $rootScope.calculateCart();

                          $state.go("landing.home");
                        },
                        function (error) {
                          console.log(error);

                          $window.swal(
                            "¡Error!",
                            "Algo salio mal, intentalo mas tarde",
                            "error"
                          );
                        }
                      );

                      // console.log(newBillingData);
                    } else {
                      $localStorage.cart = $rootScope.cart = {
                        totalBalance: 0,
                        totalPrice: 0,
                        couponDiscount: 0,
                        coupon: {},
                        items: [],
                        productIds: [],
                        serviceIds: [],
                      };

                      vm.cardData = {};
                      vm.billingData = {};

                      $rootScope.calculateCart();

                      $state.go("landing.home");
                    }
                  }

                  $window.swal(
                    resp.response.notificationTitle,
                    resp.response.notificationMessage,
                    resp.response.notificationType
                  );
                }
              );
            },
            function (error) {
              console.log(error);

              $window.swal("¡Error!", error.message_to_purchaser, "error");
            }
          );
        } else {
          $rootScope.cart.purchaseDate = new Date();
          $rootScope.cart.deliveryPrice = vm.temporalDeliveryAmount;
          console.log($rootScope.deliveryPrice);
          console.log(vm.temporalDeliveryAmount);
          console.log($rootScope.cart)
          Sale.createSale(
            {
              cart: $rootScope.cart,
            },
            function (resp) {
              console.log(resp);
               console.log($rootScope.cart);

              if (resp.response.success) {
                if ($rootScope.cart.billRequired && vm.billingData) {
                  vm.billingData.saleId = resp.response.id;

                  BillingData.create(
                    vm.billingData,
                    function (success) {
                      $localStorage.cart = $rootScope.cart = {
                        totalBalance: 0,
                        totalPrice: 0,
                        couponDiscount: 0,
                        coupon: {},
                        items: [],
                        productIds: [],
                        serviceIds: [],
                      };

                      vm.cardData = {};
                      vm.billingData = {};

                      $rootScope.calculateCart();

                      $state.go("landing.home");
                    },
                    function (error) {
                      console.log(error);

                      $window.swal(
                        "¡Error!",
                        "Algo salio mal, intentalo mas tarde",
                        "error"
                      );
                    }
                  );

                  // console.log(newBillingData);
                } else {
                  $localStorage.cart = $rootScope.cart = {
                    totalBalance: 0,
                    totalPrice: 0,
                    couponDiscount: 0,
                    coupon: {},
                    items: [],
                    productIds: [],
                    serviceIds: [],
                  };

                  vm.cardData = {};
                  vm.billingData = {};

                  $rootScope.calculateCart();

                  $state.go("landing.home");
                }
              }

              $window.swal(
                resp.response.notificationTitle,
                resp.response.notificationMessage,
                resp.response.notificationType
              );
            }
          );
        } 
      }

      vm.validateCity = function () {
        var cityDownCase = $rootScope.cart.client.address.city
          ? $rootScope.cart.client.address.city.toLowerCase()
          : undefined;

        vm.cityFreeShipping =
          cityDownCase == "zapopan" ||
          cityDownCase == "guadalajara" ||
          cityDownCase == "tlaquepaque" ||
          cityDownCase == "tonalá" ||
          cityDownCase == "tonala" ||
          cityDownCase == "tlajomulco de zuñiga" ||
          cityDownCase == "tlajomulco";

        if (vm.cityFreeShipping) {

          $rootScope.cart.deliveryType = "validate";
          vm.updateDeliveryBillAmount(vm.shipmentOptions.zmg);
        } else {
          $rootScope.cart.deliveryType = "normal";
          vm.updateDeliveryBillAmount(vm.shipmentOptions.country);

        }
        if (
          !vm.cityFreeShipping &&
          $rootScope.cart.deliveryType == "validate"
        ) {
          console.log("Elimino");
         // delete $rootScope.cart.deliveryType;
        }
      };
      vm.validateState = function () {
        var stateDownCase = $rootScope.cart.client.address.state
          ? $rootScope.cart.client.address.state.toLowerCase()
          : undefined;

        vm.cityFreeShipping = stateDownCase === "jalisco";

        var cityDownCase = $rootScope.cart.client.address.city
          ? $rootScope.cart.client.address.city.toLowerCase()
          : undefined;

        var freeCity =
          cityDownCase == "zapopan" ||
          cityDownCase == "guadalajara" ||
          cityDownCase == "tlaquepaque" ||
          cityDownCase == "tonalá" ||
          cityDownCase == "tonala" ||
          cityDownCase == "tlajomulco de zuñiga" ||
          cityDownCase == "tlajomulco";

        if (vm.cityFreeShipping && freeCity) {
          $rootScope.cart.deliveryType = "validate";
          vm.updateDeliveryBillAmount(vm.shipmentOptions.zmg);

        } else {
          $rootScope.cart.deliveryType = "normal";
          vm.updateDeliveryBillAmount(vm.shipmentOptions.country);

        }
        if (
          !vm.cityFreeShipping &&
          $rootScope.cart.deliveryType == "validate"
        ) {
          console.log("Elimino");
         // delete $rootScope.cart.deliveryType;
        }
      };
    }
  );

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider.state('landing.shopping.cart', {
      url: "/carrito",
      views: {
        shopping: {
          templateUrl: "app/landing/shopping/cart/cart.html"
        }
      },
      data: {
        pageTitle: 'Shopping Cart'
      }
    });
  })
  .controller('ShoppingCartController', function($localStorage, $rootScope, $window, $state, Sale) {

    var vm = this;

    function init() {
      scrollWin();
      getContent();
    }

    init();

    function scrollWin() {
      $window.scrollTo(0, 0);
    }

    function getContent() {
      Sale.getItemsInfo({
        cart: $rootScope.cart
      }, function(resp) {
        console.log(resp.response);

        if (resp.response.success) {
          $localStorage.cart = $rootScope.cart = resp.response.verifiedCart;

          if (resp.response.hasChanged) {
            $window.swal(
              '¡Atencion!',
              'Algunos articulos de tu carrito han cambiado',
              'warning'
            );
          }
        }
      });
    }

    vm.updateQuantity = function(item, quantityUpdate) {
      item.presentation.quantity += quantityUpdate;

      $rootScope.calculateCart();
    };

    vm.deleteItem = function(index) {
      console.log('Delete')
      $rootScope.cart.items.splice(index, 1);

      if (!$rootScope.cart.items.length && vm.code) {
        delete vm.code;
      }

      $rootScope.calculateCart();
    };

    vm.checkCode = function() {
      if ($rootScope.cart.productIds.length || $rootScope.cart.serviceIds.length) {
        var tempocalCart = JSON.parse(JSON.stringify($rootScope.cart));

        tempocalCart.coupon.code = vm.code;

        Sale.getItemsInfo({
          cart: tempocalCart
        }, function(resp) {
          console.log(resp.response);

          if (resp.response.success) {
            switch (true) {
              case !resp.response.couponExists:
                $window.swal(
                  '¡Error!',
                  'El código ingresado no existe',
                  'error'
                );
                break;
              case resp.response.couponExpired:
                $window.swal(
                  '¡Error!',
                  'El código ingresado ya expiró',
                  'warning'
                );
                break;
              default:
                $localStorage.cart = $rootScope.cart = resp.response.verifiedCart;

                if (resp.response.hasChanged) {
                  $window.swal(
                    '¡Atencion!',
                    'Algunos articulos de tu carrito han cambiado',
                    'warning'
                  );
                }
            }
          }
        });
      }
    };

    vm.goToCheckout = function() {
      $state.go('landing.shopping.checkout');
    };

  });

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider.state('landing.services.all', {
      url: "/?categoria",
      views: {
        services: {
          templateUrl: "app/landing/services/all/all.html"
        }
      },
      data: {
        pageTitle: 'All Services'
      }
    });
  })
  .controller('ServicesAllController', function($window, $state, $stateParams, Category, Service) {

    var vm = this;

    function init() {
      scrollWin();
      getContent();
    }

    init();

    function scrollWin() {
      $window.scrollTo(0, 0);
    }

    function getContent() {
      if ($stateParams.categoria) {
        Category.findOne({
          filter: {
            where: {
              urlName: $stateParams.categoria
            }
          }
        }, function(category) {
          vm.infoCategory = category;

          vm.services = Service.find({
            filter: {
              where: {
                categoryId: category.id,
                isActive: true,

              }
            }
          }, function() {
            initializeSclick();
          });
        });
      } else {
        Category.findOne({
          filter: {
            where: {
              isActive: true,
              type: "service"
            }
          }
        }, function(category) {
          vm.infoCategory = category;

          vm.services = Service.find({
            filter: {
              where: {
                isActive: true,
                categoryId: category.id
              }
            }
          }, function() {
            initializeSclick();
          });
        });
      }
    }

    function initializeSclick() {
      $(document).ready(function() {
        $('.services-slick').slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          responsive: [{
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 426,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      });
    }

  });

"use strict";

angular
  .module("inspinia")
  .config(function ($stateProvider) {
    $stateProvider.state("landing.services.service", {
      url: "/servicio/:nombre",
      views: {
        services: {
          templateUrl: "app/landing/services/service/service.html",
        },
      },
      data: {
        pageTitle: "Services Service",
      },
    });
  })
  .controller(
    "ServicesServiceController",
    function ($rootScope, $window, $state, $stateParams, Service, Product) {
      var vm = this;

      function init() {
        scrollWin();
        getContent();
      }

      init();

      function scrollWin() {
        $window.scrollTo(0, 0);
      }

      function getContent() {
        Service.findOne(
          {
            filter: {
              where: {
                urlName: $stateParams.nombre,
              },
            },
          },
          function (service) {
            vm.service = service;

            console.log(service);
            if (service.isActive) {
              var indexCart = $rootScope.cart.items.findIndex(function (item) {
                return item.id == vm.service.id;
              });

              if (indexCart >= 0) {
                vm.unitSelected = JSON.parse(
                  JSON.stringify($rootScope.cart.items[indexCart].presentation)
                );
              } else {
                vm.unitSelected = {
                  quantity: 1,
                  cost: vm.service.cost,
                };
              }

              vm.suggestedServices = Service.find({
                filter: {
                  where: {
                    id: {
                      inq: service.suggestedServices,
                    },
                  },
                },
              });

              vm.suggestedProducts = Product.find({
                filter: {
                  where: {
                    id: {
                      inq: service.suggestedProducts,
                    },
                  },
                },
              });
            } else {
              $window.swal(
                "¡Atencion!",
                "Este articulo no se encuentra disponible, sera redirigido al inicio",
                "warning"
              );
              setTimeout(function () {
                window.location.href = "https://cosmetomedica.com/#/";
              }, 1000);
            }
            initializeSclick();
          }
        );
      }

      function initializeSclick() {
        $(document).ready(function () {
          $(".slider-slick").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            asNavFor: ".slider-nav",
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  dots: false,
                },
              },
            ],
          });

          $(".slider-nav").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: ".slider-slick",
            centerMode: true,
            focusOnSelect: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 992,
                settings: "unslick",
              },
            ],
          });

          $(".befaft-slick").slick({
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1025,
                settings: {
                  arrows: true,
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 769,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 426,
                settings: {
                  arrows: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          });
        });
      }

      vm.addToCart = function () {
        var index = $rootScope.cart.items.findIndex(function (item) {
          return item.id == vm.service.id;
        });

        if (index >= 0) {
          $rootScope.cart.items[index].presentation = JSON.parse(
            JSON.stringify(vm.unitSelected)
          );

          $rootScope.calculateCart();
        } else {
          $rootScope.cart.items.push({
            id: vm.service.id,
            isService: true,
            presentation: JSON.parse(JSON.stringify(vm.unitSelected)),
          });

          $rootScope.calculateCart();
        }
      };
    }
  );

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider
      .state('landing.products', {
        url: "/productos",
        abstract: true,
        views: {
          landing: {
            templateUrl: "app/landing/products/products.html",
            controller: ProductsController
          }
        },
        data: {
          pageTitle: 'Products'
        }
      })
  });

function ProductsController() {

}

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider
      .state('landing.shopping', {
        url: "/compras",
        abstract: true,
        views: {
          landing: {
            templateUrl: "app/landing/shopping/shopping.html",
            controller: ShoppingController
          }
        },
        data: {
          pageTitle: 'Shopping'
        }
      })
  });

function ShoppingController() {}

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider.state('landing.home', {
      url: "/",
      views: {
        landing: {
          templateUrl: "app/landing/home/home.html"
        }
      },
      data: {
        pageTitle: 'Home'
      }
    });
  })
  .controller('HomeController', function($window, $state, $rootScope, Service, Product, Testimony, HomeConfig, Category) {

    var vm = this;

    function init() {
      scrollWin();
      getContent();
    }

    init();

    function scrollWin() {
      $window.scrollTo(0, 0);
    }

    function getContent() {
      Category.find({
        filter: {
          where: {
            isActive: true,
            type: "service"
          }
        }
      }, function(categories) {

        categories.forEach(function(category) {
          var nameSepared = category.name.split(" ", 1);
          category.nameFirst = nameSepared[0];
          category.nameLast = category.name.substring(nameSepared[0].length + 1, category.name.length);
        });

        vm.categories = categories;
      });

      HomeConfig.findOne({}, function(home) {

        vm.popularServices = Service.find({
          filter: {
            where: {
              id: {
                inq: home.services
              }
            }
          }
        });

        vm.popularProducts = Product.find({
          filter: {
            where: {
              id: {
                inq: home.products
              }
            }
          }
        });

        vm.testimonies = Testimony.find({
          filter: {
            where: {
              id: {
                inq: home.serviceTestimonies
              }
            }
          }
        });

        vm.home = home;

        initializeSclick();

      }, function(err) {
        $log.log(err)
      });
    }

    function initializeSclick() {
      $(document).ready(function() {
        $('.slider-slick').slick({
          dots: true,
          arrows: false,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000
        });

        $('.categories-slick').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          mobileFirst: true,
          responsive: [{
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        $('.general-slick .categories-slick .thumbnail').on('edge', function(event, slick, direction) {
          // angular.element(event).
          console.log(event, slick, direction);
        });
      });
    }
  });

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider.state('landing.we', {
      url: "/nosotros",
      views: {
        landing: {
          templateUrl: "app/landing/we/we.html"
        }
      },
      data: {
        pageTitle: 'We'
      }
    });
  })
  .controller('WeController', function($log, $window, $state, HomeConfig) {

    var vm = this;

    function init() {
      scrollWin();
      getContent();
    }

    init();

    function scrollWin() {
      $window.scrollTo(0, 0);
    }

    function getContent() {
      HomeConfig.findOne({
          filter: {
            fields: {
              weData: true
            }
          }
        },
        function(informative) {
          $log.log("informative: ", informative);

          vm.we = informative.weData;
        },
        function(err) {
          $log.log(err)
        });
    }

  });

'use strict';

angular.module('inspinia')
  .config(function($stateProvider) {
    $stateProvider
      .state('landing.services', {
        url: "/servicios",
        abstract: true,
        views: {
          landing: {
            templateUrl: "app/landing/services/services.html",
            controller: ServicesController
          }
        },
        data: {
          pageTitle: 'Services'
        }
      })
  });

function ServicesController() {}

"use strict";

angular
  .module("inspinia")
  .config(function ($stateProvider) {
    $stateProvider.state("landing.media", {
      url: "/medios",
      views: {
        landing: {
          templateUrl: "app/landing/media/media.html",
        },
      },
      data: {
        pageTitle: "Media",
      },
    });
  })
  .controller(
    "MediaController",
    function ($window, $state, Media, HomeConfig, $sce, $scope) {
      var vm = this;

      function init() {
        scrollWin();
        getContent();
      }

      init();

      function scrollWin() {
        $window.scrollTo(0, 0);
      }
      $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
      };

      function getContent() {
        Media.getMediaWeb(function (resp) {
          console.log(resp);
          vm.mediaData = resp.response.mediaData;
          vm.videos = resp.response.videos;
          vm.channels = resp.response.channels;
          vm.programs = resp.response.programs;
          vm.bulletin = resp.response.bulletin;
          vm.catalog = resp.response.catalog;
          vm.publicPrices = resp.response.publicPrices;
          vm.profesionalPrices = resp.response.profesionalPrices;
        });
      }
    }
  );

"use strict";

angular
  .module("inspinia")
  .config(function ($stateProvider) {
    $stateProvider.state("landing", {
      templateUrl: "app/landing/landing.html",
      abstract: true,
      data: {
        pageTitle: "Landing",
      },
    });
  })
  .controller(
    "LandingController",
    function ($state, $rootScope, $localStorage, Sale) {
      if ($localStorage.cart) {
        $rootScope.cart = $localStorage.cart;
      } else {
        $localStorage.cart = $rootScope.cart = {
          totalBalance: 0,
          totalPrice: 0,
          couponDiscount: 0,
          coupon: {},
          items: [],
          productIds: [],
          serviceIds: [],
        };
      }
      // Testing Key
      //  Conekta.setPublicKey("key_HWrHs367jYXnvuhrM6nmacg");

      
      // Production Key
      Conekta.setPublicKey("key_boFZzKxU3wecfy8z8M2eyFw");
      Conekta.setLanguage("es");

      $rootScope.goTo = function (where, urlName) {
        switch (where) {
          case "services":
            $state.go("landing.services.all", {
              categoria: urlName,
            });
            break;
          case "service":
            $state.go("landing.services.service", {
              nombre: urlName,
            });
            break;
          case "products":
            $state.go("landing.products.all", {
              categoria: urlName,
            });
            break;
          case "product":
            $state.go("landing.products.product", {
              nombre: urlName,
            });
            break;
        }
      };

      $rootScope.calculateCart = function () {
        if ($rootScope.cart.items.length) {
          $rootScope.cart.items.forEach(function (item) {
            if (
              item.isProduct &&
              $rootScope.cart.productIds.every(function (productId) {
                return productId != item.id;
              })
            ) {
              $rootScope.cart.productIds.push(item.id);
            } else if (
              item.isService &&
              $rootScope.cart.serviceIds.every(function (serviceId) {
                return serviceId != item.id;
              })
            ) {
              $rootScope.cart.serviceIds.push(item.id);
            }
          });
        } else {
          $rootScope.cart.productIds = [];
          $rootScope.cart.serviceIds = [];
        }

        Sale.getItemsInfo(
          {
            cart: $rootScope.cart,
          },
          function (resp) {
            if (resp.response.success) {
              $localStorage.cart = $rootScope.cart = resp.response.verifiedCart;

              if (resp.response.hasChanged) {
                console.log("Algunos elementos cambiaron ALV");
              }
            }
          }
        );
      };
    }
  )
  .controller(
    "MenuController",
    function ($log, $state, $filter, $rootScope, Category, AppUser) {
      var vm = this;

      function init() {
        variables();
      }

      init();

      function variables() {
        vm.searchText = "";
        vm.searchResult = "";
        vm.timer;

        vm.toggleMenu = false;

        vm.allServices = Category.find({
          filter: {
            where: {
              isActive: true,
              type: "service",
            },
          },
        });

        vm.allProducts = Category.find({
          filter: {
            where: {
              isActive: true,
              type: "product",
            },
          },
        });
      }

      function searchNow() {
        if (vm.searchText) {
          AppUser.search(
            {
              input: vm.searchText,
              type: "Services",
            },
            function (data) {
              console.log(data);
            },
            function (err) {
              console.log(err);
            }
          );
        }
      }

      vm.search = function (event) {
        if (event && event.charCode == 13) {
          if (vm.timer) {
            clearTimeout(vm.timer);
          }

          searchNow();
        } else {
          if (vm.timer) {
            clearTimeout(vm.timer);
          }

          vm.timer = setTimeout(function () {
            searchNow();
          }, 500);
        }
      };

      vm.resetSearch = function () {
        if (!vm.searchText) {
          vm.searchResult = "";
        } else {
          vm.search();
        }
      };
    }
  );

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 71;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 71 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, LoopBackResourceProvider, ENV) {
    LoopBackResourceProvider.setUrlBase(ENV.APIURL + '/api');

    $urlRouterProvider.otherwise(ENV.BASEURL);

    LoopBackResourceProvider.setAuthHeader('X-Access-Token');

    $stateProvider.state('index', {
      abstract: true,
      templateUrl: "app/components/common/content_top_navigation.html"
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .constant('ENV', {
      //APIURL: 'https://cosmetomedica-api-dev.aleate.com',
       APIURL: 'https://api.cosmetomedica.com',

      BASEURL: '/',

      ENABLEDEBUG: true,

      VERSION: "1.2.5"
    })
    .config(disableLogging)
    .controller('IndexController', function($rootScope, ENV) {
      $rootScope.version = ENV.VERSION;
    });

  /** @ngInject */
  function disableLogging($logProvider, ENV) {
    $logProvider.debugEnabled(ENV.ENABLEDEBUG);

    if (!ENV.ENABLEDEBUG) {
      console = function() {}
    }
  };
})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });



angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/landing/landing.html","<div id=\"wrapper\" class=\"top-navigation\"><div ng-include=\"\'app/components/common/top_navigation.html\'\"></div><div id=\"page-wrapper\" class=\"white-bg\"><div ng-controller=\"LandingController as vm\" ui-view=\"landing\" class=\"wrapper-content\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"row\"><div class=\"col-md-2 col-xs-12 logo-img\"><img ng-src=\"assets/images/logo_white_text.png\" class=\"cmed-navbar-logo\"><p>Todos los derechos reservados 2018. v{{version}}</p></div><div class=\"col-md-2 col-xs-12 sn-links\"><div class=\"col-xs-4\"><a href=\"https://www.youtube.com/channel/UCCqBD1i6_C0bG501ySL_xFA\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-youtube\"></i></button></a></div><div class=\"col-xs-4\"><a href=\"https://www.instagram.com/cosmetomedica/\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-instagram\"></i></button></a></div><div class=\"col-xs-4\"><a href=\"https://www.facebook.com/COSMETOMEDICA-169786979745693/\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-facebook\"></i></button></a></div></div><div class=\"col-md-4 col-xs-12 legal-links\"><div class=\"col-xs-5\"><a href=\"assets/terminos_y_condiciones_cosmetomedica.pdf\" target=\"_blank\"><p>Términos y condiciones</p></a></div><div class=\"col-xs-2\"><i class=\"fa fa-circle\"></i></div><div class=\"col-xs-5\"><a href=\"assets/aviso_de_privacidad_cosmetomedica.pdf\" target=\"_blank\"><p>Aviso de privacidad</p></a></div></div><div class=\"col-md-4 col-xs-12 menu-links\"><div><a href=\"\" ui-sref=\"landing.home\"><p>Inicio</p></a></div><div><a href=\"\" ui-sref=\"landing.services.all\"><p>Servicios</p></a></div><div><a href=\"\" ui-sref=\"landing.products.all\"><p>Productos</p></a></div><div><a href=\"\" ui-sref=\"landing.we\"><p>Nosotros</p></a></div><div><a href=\"\" ui-sref=\"landing.media\"><p>Medios</p></a></div></div></div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/top_navigation.html","<div class=\"row border-bottom white-bg\"><nav ng-controller=\"MenuController as vm\" class=\"navbar navbar-fixed-top\" role=\"navigation\"><div class=\"navbar-header\"><button aria-controls=\"navbar\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\" aria-expanded=\"false\" data-target=\"#navbar\" data-toggle=\"collapse\" class=\"navbar-toggle collapsed\" type=\"button\"><i class=\"fa fa-reorder\"></i></button> <a href=\"#/compras/carrito\" class=\"navbar-header-button-shopping hidden-sm hidden-md hidden-lg\"><button class=\"btn btn-default btn-circle btn-lg button-shopping\" type=\"button\"><i class=\"fa fa-shopping-cart\"></i> Carrito: {{cart.totalBalance || 0 | currency}}</button></a> <a href=\"#\" class=\"navbar-header-cmed-logo hidden-xs\"><img ng-src=\"assets/images/logo_black_text.png\" class=\"cmed-navbar-logo\"></a></div><div class=\"navbar-collapse collapse\" ng-class=\"vm.toggleMenu ? \'show\': \'\'\" id=\"navbar\"><ul class=\"nav navbar-right navbar-top-links hidden-xs\"><li><a href=\"#/compras/carrito\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\"><button class=\"btn btn-default btn-circle btn-lg button-shopping\" type=\"button\"><i class=\"fa fa-shopping-cart\"></i> Carrito: {{cart.totalBalance || 0 | currency}}</button></a></li></ul><ul class=\"nav navbar-right navbar-top-links\"><li><a href=\"https://www.youtube.com/channel/UCCqBD1i6_C0bG501ySL_xFA\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-youtube\"></i></button></a></li><li><a href=\"https://www.instagram.com/cosmetomedica/\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-instagram\"></i></button></a></li><li><a href=\"https://www.facebook.com/COSMETOMEDICA-169786979745693/\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-facebook\"></i></button></a></li><li><a href=\"#/nosotros#contact\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-phone\"></i></button></a></li></ul><ul class=\"nav navbar-nav navbar-right navbar-list\"><li ui-sref-active=\"active\" uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\" ui-sref=\"landing.home\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\"><span class=\"nav-label\">Inicio</span></a></li><li ui-sref-active=\"active\" uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><span class=\"nav-label\">Servicios</span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"item in vm.allServices\"><a ui-sref=\"landing.services.all({categoria: item.urlName})\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\">{{item.name}}</a></li><li hidden=\"\"><a ui-sref=\"landing.services.service\"></a></li></ul></li><li ui-sref-active=\"active\" uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><span class=\"nav-label\">Productos</span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"item in vm.allProducts\"><a ui-sref=\"landing.products.all({categoria: item.urlName})\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\">{{item.name}}</a></li><li hidden=\"\"><a ui-sref=\"landing.products.product\"></a></li></ul></li><li ui-sref-active=\"active\" uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\" ui-sref=\"landing.we\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\"><span class=\"nav-label\">Nosotros</span></a></li><li ui-sref-active=\"active\" uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\" ui-sref=\"landing.media\" ng-click=\"vm.toggleMenu = !vm.toggleMenu\"><span class=\"nav-label\">Medios</span></a></li></ul></div></nav></div>");
$templateCache.put("app/landing/products/products.html","<div ui-view=\"products\"></div>");
$templateCache.put("app/landing/home/home.html","<div ng-controller=\"HomeController as vm\" class=\"home animated fadeInDown\"><div class=\"slider-slick\"><div ng-repeat=\"item in vm.home.slider\"><img ng-src=\"{{item.imageUrl}}\"><div class=\"banner-text\"><h2>{{item.title}}</h2><h3>{{item.subtitle}}</h3><button type=\"button\" class=\"btn btn-lg btn-primary\" ng-if=\"item.showMore\" ng-click=\"goTo(item.type, item.element)\">Ver más</button></div></div></div><div class=\"row general-box categories-box gray-bg\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Servicios</h2><p>Conoce todo lo que tenemos para tí</p></div><div class=\"col-xs-12 general-slick\"><div class=\"categories-slick\"><div class=\"thumbnail\" ng-repeat=\"item in vm.categories\" ng-click=\"goTo(\'services\', item.urlName)\"><img ng-src=\"{{item.iconUrl}}\"><div class=\"caption\"><h3>{{item.nameFirst}}</h3><p>{{item.nameLast}}</p></div><div class=\"line\"></div></div></div></div></div><div class=\"row general-box popular-services\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Tratamientos populares</h2><p>Los favoritos de nuestros clientes</p></div><div class=\"col-sm-4 col-xs-12 content-box\" ng-repeat=\"item in vm.popularServices\" ng-click=\"goTo(\'service\', item.urlName)\"><img ng-src=\"{{item.bannerUrl}}\"> <span>{{item.name}}</span></div></div><div class=\"row testimonies\"><h2>Testimonios</h2><div class=\"col-sm-6 content-box\" ng-repeat=\"item in vm.testimonies\"><div class=\"profile-image\"><img ng-src=\"{{item.imageUrl}}\" class=\"rounded-circle circle-border m-b-md\"></div><div class=\"profile-info\"><div class=\"stars-container\"><span class=\"fa\" ng-class=\"item.rating >= 1 ? \'fa-star checked\' : \'fa-star-o\'\"></span> <span class=\"fa\" ng-class=\"item.rating >= 2 ? \'fa-star checked\' : \'fa-star-o\'\"></span> <span class=\"fa\" ng-class=\"item.rating >= 3 ? \'fa-star checked\' : \'fa-star-o\'\"></span> <span class=\"fa\" ng-class=\"item.rating >= 4 ? \'fa-star checked\' : \'fa-star-o\'\"></span> <span class=\"fa\" ng-class=\"item.rating >= 5 ? \'fa-star checked\' : \'fa-star-o\'\"></span></div><h2 class=\"no-margins\">{{item.name}}</h2></div><p>{{item.description}}</p></div></div><div class=\"row general-box popular-products gray-bg\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Productos destacados</h2><p>Conoce todo lo que tenemos para tí</p></div><div class=\"col-xs-12 col-sm-6 col-md-3\" ng-repeat=\"item in vm.popularProducts\" ng-click=\"goTo(\'product\', item.urlName)\"><div class=\"thumbnail\"><img ng-src=\"{{item.bannerUrl}}\"><div class=\"caption\"><p>{{item.name}}</p><h3 ng-if=\"item.units.length\">desde {{item.units[0].cost | currency}}</h3></div></div></div></div><div class=\"row general-box location\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Ubicación</h2></div><a href=\"https://www.google.com/maps/dir//Cosmetomedica/\" target=\"_blank\"><img src=\"https://maps.googleapis.com/maps/api/staticmap?center=Cosmetomedica&zoom=16&scale=2&size=640x200&maptype=roadmap&key=AIzaSyCkxxRTrV0mvXTgWrTQAg9edQXMQtdudjA&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7CCosmetomedica\" alt=\"Google Map of Cosmetomedica\"></a></div></div>");
$templateCache.put("app/landing/media/media.html","<div ng-controller=\"MediaController as vm\" class=\"media-cmed animated fadeInDown\"><div class=\"row general-box videos-box\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Videos</h2><p>Los últimos videos</p></div><div class=\"col-xs-12 video-images\"><div class=\"col-sm-4 col-xs-12 video-element\" ng-repeat=\"item in vm.videos\" ng-class=\"(vm.videos.length == 1 ? \'col-sm-4 col-sm-offset-4\': (vm.videos.length == 2 && $first ? \'col-sm-4 col-sm-offset-2\' : \'\'))\"><a href=\"{{item.mediaUrl}}\" target=\"_blank\"><img ng-src=\"{{item.imageUrl}}\"> <i class=\"fa fa-play\"></i></a></div></div></div><div class=\"row about-me gray-bg\"><div class=\"col-sm-6 col-xs-12 image-about\"><img ng-src=\"{{vm.mediaData.imageUrl}}\" class=\"rounded-circle m-b-md\"></div><div class=\"col-sm-6 col-xs-12 text-about\"><h2>Tania Romero</h2><h3 class=\"blue-sub\">Directora de Cosmetomedica</h3><h3>Acerca de mí:</h3><p ng-bind-html=\"vm.mediaData.text\"></p></div></div><div class=\"row general-box channels-box\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Canales</h2><p>Escucha a Tania y aprende todo acerca de nuestros tratamientos.</p></div><div class=\"col-xs-12 channel-images\"><div class=\"col-md-6 col-xs-12 channel-element\" ng-repeat=\"item in vm.channels\" ng-class=\"vm.channels.length%2 == 1 && $last ? \'col-md-offset-3\': \'\'\"><div class=\"col-sm-6 col-xs-12\"><a href=\"{{item.mediaUrl}}\" target=\"_blank\"><img ng-src=\"{{item.imageUrl}}\"><div class=\"play-label\"><i class=\"fa fa-play\"></i></div></a></div><div class=\"col-sm-6 col-xs-12 channel-text\"><h3>{{item.name}}</h3><p>{{item.days}}</p><p>{{item.schedule}}</p></div></div></div></div><div class=\"row general-box programs-box gray-bg\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Programas</h2></div><div class=\"col-xs-12 program-images\"><div class=\"program-element\" ng-repeat=\"item in vm.programs\" ng-class=\"(vm.programs.length == 1 ? \'col-sm-4 col-sm-offset-4\': (vm.programs.length == 2 && $first ? \'col-sm-5 col-sm-offset-1 col-xs-12\' : (vm.programs.length == 2 && $last ? \'col-sm-5 col-xs-12\': (vm.programs.length == 3 ? \'col-sm-4 col-xs-12\': \'col-md-3 col-sm-6 col-xs-12\'))))\"><a href=\"{{item.mediaUrl}}\" target=\"_blank\"><img ng-src=\"{{item.imageUrl}}\"><p>{{item.name}}</p><div class=\"play-label\"><i class=\"fa fa-play\"></i></div></a></div></div></div><div ng-if=\"vm.bulletin\" class=\"row general-box programs-box gray-bg pad-20\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Boletín</h2></div><div class=\"col-xs-12 program-images\"><div class=\"program-element\" ng-repeat=\"item in vm.bulletin\" ng-class=\"(vm.bulletin.length == 1 ? \'col-sm-4 col-sm-offset-4\': (vm.bulletin.length == 2 && $first ? \'col-sm-5 col-sm-offset-1 col-xs-12\' : (vm.bulletin.length == 2 && $last ? \'col-sm-5 col-xs-12\': (vm.bulletin.length == 3 ? \'col-sm-4 col-xs-12\': \'col-md-3 col-sm-6 col-xs-12\'))))\"><div class=\"row\"><a href=\"{{item.imageUrl}}\" target=\"_blank\"><img ng-src=\"{{item.mediaUrl}}\"><p>{{item.name}}</p></a></div><div class=\"row\"></div></div></div></div><div ng-if=\"vm.catalog\" class=\"row general-box programs-box gray-bg\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Catálogo</h2></div><div class=\"col-xs-12 program-images\"><div class=\"program-element\" ng-repeat=\"item in vm.catalog\" ng-class=\"(vm.catalog.length == 1 ? \'col-sm-4 col-sm-offset-4\': (vm.catalog.length == 2 && $first ? \'col-sm-5 col-sm-offset-1 col-xs-12\' : (vm.catalog.length == 2 && $last ? \'col-sm-5 col-xs-12\': (vm.catalog.length == 3 ? \'col-sm-4 col-xs-12\': \'col-md-3 col-sm-6 col-xs-12\'))))\"><div class=\"row\"><a href=\"{{item.imageUrl}}\" target=\"_blank\"><img ng-src=\"{{item.mediaUrl}}\"><p>{{item.name}}</p></a></div><div class=\"row\"></div></div></div></div><div ng-if=\"vm.publicPrices\" class=\"row general-box programs-box gray-bg\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Lista de precios publico</h2></div><div class=\"col-xs-12 program-images\"><div class=\"program-element\" ng-repeat=\"item in vm.publicPrices\" ng-class=\"(vm.publicPrices.length == 1 ? \'col-sm-4 col-sm-offset-4\': (vm.publicPrices.length == 2 && $first ? \'col-sm-5 col-sm-offset-1 col-xs-12\' : (vm.publicPrices.length == 2 && $last ? \'col-sm-5 col-xs-12\': (vm.publicPrices.length == 3 ? \'col-sm-4 col-xs-12\': \'col-md-3 col-sm-6 col-xs-12\'))))\"><div class=\"row\"><a href=\"{{item.imageUrl}}\" target=\"_blank\"><img ng-src=\"{{item.mediaUrl}}\"><p>{{item.name}}</p></a></div><div class=\"row\"></div></div></div></div></div>");
$templateCache.put("app/landing/services/services.html","<div ui-view=\"services\"></div>");
$templateCache.put("app/landing/we/we.html","<div ng-controller=\"WeController as vm\" class=\"we animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 banner-box\"><img ng-src=\"{{vm.we.imageUrl}}\"></div></div><div class=\"row general-box info-we\"><div class=\"col-xs-12 header-box\"><h2>Nosotros</h2></div><div class=\"col-md-10 col-md-offset-1 content-box\"><p ng-bind-html=\"vm.we.text\"></p><div class=\"line\"></div></div></div><div class=\"row general-box contact-info\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Contacto</h2></div><div class=\"col-md-8 col-xs-12 contact-map\"><a href=\"https://www.google.com/maps/dir//Cosmetomedica/\" target=\"_blank\"><img src=\"https://maps.googleapis.com/maps/api/staticmap?center=Cosmetomedica&zoom=16&scale=2&size=640x200&maptype=roadmap&key=AIzaSyCkxxRTrV0mvXTgWrTQAg9edQXMQtdudjA&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:%7CCosmetomedica\" alt=\"Google Map of Cosmetomedica\"></a></div><div class=\"col-md-4 contact-links\"><img ng-src=\"assets/images/logo_black_text.png\"><div class=\"row\"><div class=\"col-sm-4\"><a href=\"https://www.youtube.com/channel/UCCqBD1i6_C0bG501ySL_xFA\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-youtube\"></i></button></a></div><div class=\"col-sm-4\"><a href=\"https://www.instagram.com/cosmetomedica/\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-instagram\"></i></button></a></div><div class=\"col-sm-4\"><a href=\"https://www.facebook.com/COSMETOMEDICA-169786979745693/\" target=\"_blank\"><button class=\"btn btn-default btn-circle btn-lg\" type=\"button\"><i class=\"fa fa-facebook\"></i></button></a></div></div></div></div><div class=\"row contact-data\"><div class=\"col-xs-12\"><i class=\"fa fa-map-marker\"></i> Justo Sierra #2272 Guadalajara, Jalisco.</div><div class=\"col-xs-12\" id=\"contact\"><i class=\"fa fa-phone\" aria-hidden=\"true\"></i> <a href=\"tel:333 630 1414\">333 630 1414</a>, <a href=\"tel:333 630 2414\">333 630 2414</a></div><div class=\"col-xs-12\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> <a href=\"mailto:cosmetomedica@hotmail.com\" target=\"_blank\">cosmetomedica@hotmail.com</a></div></div></div>");
$templateCache.put("app/landing/shopping/shopping.html","<div ui-view=\"shopping\"></div>");
$templateCache.put("app/landing/products/all/all.html","<div ng-controller=\"ProductsAllController as vm\" class=\"products-all animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 banner-box\"><img ng-src=\"{{vm.infoCategory.bannerUrl}}\"><div class=\"banner-text\"><h2>{{vm.infoCategory.name}}</h2><h3>{{vm.infoCategory.title}}</h3><h3>{{vm.infoCategory.subtitle}}</h3><p>{{vm.infoCategory.description}}</p></div></div></div><div class=\"row general-box info-products\"><div class=\"col-xs-12 general-slick\"><div class=\"products-slick\"><div class=\"thumbnail\" ng-repeat=\"item in vm.products\" ng-click=\"goTo(\'product\', item.urlName)\"><img ng-src=\"{{item.bannerUrl}}\"><div class=\"caption\"><p>{{item.name}}</p><h3 ng-if=\"item.units.length\">desde {{item.units[0].cost | currency}}</h3><h3 class=\"promo-title\">{{item.promoTitle || \"&nbsp;\"}}</h3></div></div></div></div></div></div>");
$templateCache.put("app/landing/products/product/product.html","<div ng-controller=\"ProductsProductController as vm\" class=\"products-product animated fadeInRight\"><div class=\"row general-box info-product\"><div class=\"col-sm-6 col-xs-12 img-box\"><img ng-src=\"{{vm.product.bannerUrl}}\"></div><div class=\"col-sm-6 col-xs-12 text-product\"><h1>{{vm.product.name}}</h1><div class=\"row units-row\"><div class=\"col-lg-4 col-md-6 col-xs-12 unit-box\" ng-repeat=\"item in vm.product.units\"><div class=\"unit-element\" ng-class=\"vm.unitSelected.index == $index ? \'unit-selected\' : \'\'\" ng-click=\"vm.selectItem($index)\"><h2>{{item.weight}} {{item.name}}</h2></div><div class=\"col-12\"></div></div></div><div class=\"promo-text\" ng-if=\"vm.product.hasPromo\"><h4>{{vm.product.promoTitle}}</h4><h3>{{vm.product.promoText}}</h3></div><div class=\"price-and-cart\" ng-if=\"vm.unitSelected.cost\"><div class=\"row price-unit\"><div class=\"col-xs-12\"><h2>{{vm.unitSelected.cost | currency}} <small>DISPONIBLE</small></h2></div></div><div class=\"row add-cart\"><div class=\"col-md-4 col-xs-12\"><input type=\"number\" min=\"1\" ng-model=\"vm.unitSelected.quantity\"></div><div class=\"col-md-8 col-xs-12 button-add\"><button class=\"btn btn-block btn-lg btn-primary\" type=\"button\" ng-click=\"vm.addToCart()\" ng-disabled=\"!vm.unitSelected.quantity\">Agregar al carrito</button></div></div></div></div></div><div class=\"row more-text-product gray-bg\"><div class=\"col-sm-12\"><hr class=\"hr-line-solid\"></div><div class=\"col-sm-7 more-content\"><h2>Descripción</h2><p ng-bind-html=\"vm.product.description\"></p></div><div class=\"col-sm-5 more-content\"><h2>Indicaciones</h2><p ng-bind-html=\"vm.product.indications\"></p></div></div><div class=\"row general-box popular-products\" ng-if=\"vm.suggestedProducts.length\"><div class=\"col-sm-12 header-box\"><h2 class=\"p-sm bg-primary\">Te puede interesar</h2></div><div class=\"col-sm-3\" ng-repeat=\"item in vm.suggestedProducts\" ng-click=\"goTo(\'product\', item.urlName)\"><div class=\"thumbnail\"><img ng-src=\"{{item.bannerUrl}}\"><div class=\"caption\"><p>{{item.name}}</p><h3 ng-if=\"item.units.length\">desde {{item.units[0].cost | currency}}</h3></div></div></div></div></div>");
$templateCache.put("app/landing/services/all/all.html","<div ng-controller=\"ServicesAllController as vm\" class=\"services-all animated fadeInDown\"><div class=\"row\"><div class=\"col-xs-12 banner-box\"><img ng-src=\"{{vm.infoCategory.bannerUrl}}\"><div class=\"banner-text\"><h2>{{vm.infoCategory.title}}</h2><h3>{{vm.infoCategory.subtitle}}</h3></div></div></div><div class=\"row general-box info-services\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">{{vm.infoCategory.name}}</h2><p ng-bind-html=\"vm.infoCategory.description\"></p></div><div class=\"col-xs-12 general-slick\"><div class=\"services-slick\"><div class=\"thumbnail\" ng-repeat=\"item in vm.services\" ng-click=\"goTo(\'service\', item.urlName)\"><img ng-src=\"{{item.bannerUrl}}\"><div class=\"caption\"><p>{{item.name}}</p><h3>{{item.cost | currency}}</h3><h3 class=\"promo-title\">{{item.promoTitle || \"&nbsp;\"}}</h3></div></div></div></div></div></div>");
$templateCache.put("app/landing/services/service/service.html","<div ng-controller=\"ServicesServiceController as vm\" class=\"services-service animated fadeInRight\"><div class=\"row general-box info-service\"><div class=\"col-sm-6 col-xs-12\"><div class=\"slider-box\"><div class=\"slider-slick\"><div class=\"image-slide\" ng-repeat=\"item in vm.service.images\"><img ng-src=\"{{item.imageUrl}}\"></div></div><div class=\"slider-nav\" ng-if=\"vm.service.images.length > 1\"><div ng-repeat=\"item in vm.service.images\"><img ng-src=\"{{item.imageUrl}}\"></div></div></div></div><div class=\"col-sm-6 col-xs-12 text-service\"><div class=\"col-xs-12\"><h1>{{vm.service.name}}</h1><p class=\"description-service\" ng-bind-html=\"vm.service.description\"></p></div><div class=\"promo-text\" ng-if=\"vm.service.hasPromo\"><h4>{{vm.service.promoTitle}}</h4><h3>{{vm.service.promoText}}</h3></div><div class=\"price-and-cart\"><div class=\"row price-unit\"><div class=\"col-xs-12\"><h2>{{vm.service.cost | currency}}</h2></div></div><div class=\"row add-cart\"><div class=\"col-md-4 col-xs-12\"><input type=\"number\" min=\"1\" ng-model=\"vm.unitSelected.quantity\"></div><div class=\"col-md-8 col-xs-12 button-add\"><button class=\"btn btn-block btn-lg btn-primary\" type=\"button\" ng-click=\"vm.addToCart()\" ng-disabled=\"!vm.unitSelected.quantity\">Agregar al carrito</button></div></div></div></div></div><div class=\"row general-box befaft-box\" ng-if=\"vm.service.beforeAndAfter.length\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Antes y Después</h2></div><div class=\"col-xs-12 general-slick\"><div class=\"befaft-slick\"><div class=\"thumbnail\" ng-repeat=\"item in vm.service.beforeAndAfter\"><div class=\"col-xs-12\"><div class=\"col-xs-6\"><img ng-src=\"{{item.beforeUrl}}\"></div><div class=\"col-xs-6\"><img ng-src=\"{{item.afterUrl}}\"></div></div></div></div></div></div><div class=\"row general-box popular-products gray-bg\" ng-if=\"vm.suggestedProducts.length\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">Productos recomendados para este tratamiento</h2></div><div class=\"col-sm-3 col-xs-12\" ng-repeat=\"item in vm.suggestedProducts\" ng-click=\"goTo(\'product\', item.urlName)\"><div class=\"thumbnail\"><img ng-src=\"{{item.bannerUrl}}\"><div class=\"caption\"><p>{{item.name}}</p><h3 ng-if=\"item.units.length\">desde {{item.units[0].cost | currency}}</h3></div></div></div></div><div class=\"row general-box popular-services\" ng-if=\"vm.suggestedServices.length\"><div class=\"col-xs-12 header-box\"><h2 class=\"p-sm bg-primary\">También te puede interesar</h2><p>Los favoritos de nuestros cientes</p></div><div class=\"col-sm-4 col-xs-12 content-box\" ng-repeat=\"item in vm.suggestedServices\" ng-click=\"goTo(\'service\', item.urlName)\"><img ng-src=\"{{item.bannerUrl}}\"> <span>{{item.name}}</span></div></div></div>");
$templateCache.put("app/landing/shopping/cart/cart.html","<div ng-controller=\"ShoppingCartController as vm\" class=\"cart-cmed\"><div class=\"row general-box general-cart-box animated fadeInDown\"><h2 class=\"col-xs-12 general-cart-title\">Carrito de compras</h2><div class=\"col-xs-12 col-sm-8 cart-box\"><div ng-if=\"cart.items.length\" ng-repeat=\"item in cart.items\" class=\"card row\"><div class=\"col-md-1 delete-item pull-right\" style=\"z-index: 99999;\"><button class=\"btn btn-outline btn-link btn-delete\" type=\"button\" ng-click=\"vm.deleteItem($index)\">x</button></div><div class=\"col-md-2 img-cart\" style=\"z-index: 1;\" ng-style=\"{\'background-image\': \'url({{item.bannerUrl}})\'}\"></div><div class=\"col-md-4 cart-title\"><h4>{{item.isProduct ? item.name + \" - \" + item.presentation.weight + \" \" +item.presentation.name : item.name}}</h4><p>{{item.isProduct ? \"Entrega estimada de 3 a 5 días hábiles\" : \"Confirmar cita después de compra\"}}</p></div><div class=\"col-md-2 cart-quantity\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-outline btn-link btn-quantity\" ng-click=\"vm.updateQuantity(item, -1)\" ng-disabled=\"item.presentation.quantity == 1\">-</button></span> <span class=\"form-control\">{{item.presentation.quantity}}</span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-outline btn-link btn-quantity\" ng-click=\"vm.updateQuantity(item, 1)\">+</button></span></div></div><div class=\"col-md-3 cart-price\"><h4>{{item.presentation.cost | currency}}</h4></div></div><div ng-if=\"!cart.items.length\" class=\"row\"><h3 class=\"col-xs-12 text-center\">No hay nada en tu carrito</h3></div></div><div class=\"col-xs-12 col-sm-4 ticket-box\"><div class=\"card row\"><h3 class=\"text-center\">Total de compra</h3><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 ticket-text\"><span class=\"ticket-title\">Subtotal</span> <span class=\"pull-right\">{{cart.totalPrice | currency}}</span></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 ticket-input\" ng-if=\"!cart.coupon.code\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Código de descuento\" ng-model=\"vm.code\" ng-disabled=\"!cart.items.length\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.code\" ng-click=\"vm.checkCode()\">Aplicar</button></span></div></div><div class=\"col-xs-12 ticket-text coupon-discount\" ng-if=\"cart.couponDiscount\"><span class=\"ticket-title\">Descuento</span> <span class=\"pull-right\">-{{cart.couponDiscount | currency}}</span></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 ticket-text\"><span class=\"ticket-title\">Total</span> <span class=\"pull-right ticket-total\">{{cart.totalBalance | currency}}</span></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 text-center button-checkout\"><button ng-click=\"vm.goToCheckout()\" ng-disabled=\"!cart.totalBalance\" class=\"btn btn-primary\">Proceder al pago</button></div></div></div></div></div>");
$templateCache.put("app/landing/shopping/checkout/checkout.html","<div ng-controller=\"ShoppingCheckoutController as vm\" class=\"checkout-cmed\"><form class=\"row general-box general-checkout-box animated fadeInRight\"><h2 class=\"col-xs-12 general-checkout-title\">Pago</h2><div class=\"col-xs-12 col-md-7 checkout-payment-box\"><h3>{{vm.clientFormTitle}}</h3><div class=\"row checkout-info-payment\"><div class=\"col-xs-12 form-group\"><input ng-model=\"cart.client.fullName\" class=\"form-control\" name=\"fullname\" placeholder=\"Nombre completo\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"cart.client.phone\" class=\"form-control\" name=\"tel\" placeholder=\"Teléfono\" minlength=\"10\" required=\"\" type=\"phone\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"cart.client.email\" class=\"form-control\" name=\"email\" placeholder=\"Correo electrónico\" required=\"\" type=\"email\"></div><div class=\"col-xs-12 col-md-4 form-group\" ng-if=\"cart.productIds.length\"><input ng-model=\"cart.client.address.country\" class=\"form-control\" name=\"country-name\" placeholder=\"Pais\" ng-required=\"cart.productIds.length\" type=\"text\"></div><div class=\"col-xs-12 col-md-4 form-group\" ng-if=\"cart.productIds.length\"><input ng-model=\"cart.client.address.city\" class=\"form-control\" name=\"city\" placeholder=\"Municipio\" ng-required=\"cart.productIds.length\" type=\"text\" ng-change=\"vm.validateCity()\"></div><div class=\"col-xs-12 col-md-4 form-group\" ng-if=\"cart.productIds.length\"><input ng-model=\"cart.client.address.state\" class=\"form-control\" name=\"state\" placeholder=\"Estado\" ng-change=\"vm.validateState()\" ng-required=\"cart.productIds.length\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"cart.productIds.length\"><input ng-model=\"cart.client.address.street\" class=\"form-control\" name=\"address-line1\" placeholder=\"Calle y número\" ng-required=\"cart.productIds.length\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\" ng-if=\"cart.productIds.length\"><input ng-model=\"cart.client.address.colony\" class=\"form-control\" name=\"address-line2\" placeholder=\"Colonia\" ng-required=\"cart.productIds.length\" type=\"text\"></div><div class=\"col-xs-12 col-md-4 form-group\" ng-if=\"cart.productIds.length\"><input ng-model=\"cart.client.address.zipCode\" class=\"form-control\" name=\"postal-code\" placeholder=\"Código postal\" ng-required=\"cart.productIds.length\" type=\"text\"></div><div class=\"col-xs-12 col-md-8 form-group\" ng-if=\"cart.productIds.length\"><input ng-model=\"cart.client.address.moreInfo\" class=\"form-control\" name=\"more-info\" placeholder=\"Información adicional: Ej. Edificio de color azul\" type=\"text\"></div></div><hr><div class=\"custom-checkbox checkbox checkbox-success\"><input type=\"checkbox\" id=\"checkbox1\" ng-model=\"cart.billRequired\"> <label for=\"checkbox1\"><h3>Necesito factura</h3></label></div><div class=\"custom-checkbox checkbox checkbox-success\" ng-if=\"cart.billRequired && cart.productIds.length\"><input type=\"checkbox\" id=\"checkbox2\" ng-model=\"vm.copyClientInfo\" ng-change=\"vm.validateClientInfo()\"> <label for=\"checkbox2\"><h3>Utilizar mi información de envío</h3></label></div><div class=\"row checkout-info-payment\" ng-if=\"cart.billRequired\"><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"vm.billingData.businessName\" class=\"form-control\" placeholder=\"Razón social\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"vm.billingData.rfc\" class=\"form-control\" placeholder=\"RFC\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"vm.billingData.fullName\" class=\"form-control\" placeholder=\"Nombre completo\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"vm.billingData.phone\" class=\"form-control\" placeholder=\"Teléfono\" minlength=\"10\" required=\"\" type=\"phone\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"vm.billingData.email\" class=\"form-control\" placeholder=\"Correo electrónico\" required=\"\" type=\"email\"></div><div class=\"col-xs-12 col-md-4 form-group\"><input ng-model=\"vm.billingData.country\" class=\"form-control\" placeholder=\"Pais\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-4 form-group\"><input ng-model=\"vm.billingData.city\" class=\"form-control\" placeholder=\"Municipio\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-4 form-group\"><input ng-model=\"vm.billingData.state\" class=\"form-control\" placeholder=\"Estado\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"vm.billingData.address\" class=\"form-control\" placeholder=\"Calle y número\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-6 form-group\"><input ng-model=\"vm.billingData.colony\" class=\"form-control\" placeholder=\"Colonia\" required=\"\" type=\"text\"></div><div class=\"col-xs-12 col-md-4 form-group\"><input ng-model=\"vm.billingData.zipCode\" class=\"form-control\" placeholder=\"Código postal\" required=\"\" type=\"text\"></div></div><hr><h3>Método de pago</h3><div class=\"row\"><div class=\"col-xs-12\"><uib-accordion class=\"panel-group payments-method\" close-others=\"true\"><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading\" ng-click=\"vm.selectPayment(\'card\')\"><h4 class=\"panel-title\"><a href=\"\" class=\"accordion-toggle\"><span uib-accordion-header=\"\" ng-class=\"{\'text-muted\': isDisabled}\"><i class=\"fa fa-dot-circle-o text-success pull-left icon-select\" ng-if=\"cart.paymentType == \'card\'\"></i> <i class=\"fa fa-circle-o text-success pull-left icon-select\" ng-if=\"cart.paymentType != \'card\'\"></i> Tarjeta de crédito / débito <i class=\"fa fa-cc-visa text-success pull-right\"></i> <i class=\"fa fa-cc-mastercard text-warning pull-right\"></i></span></a></h4></div></uib-accordion-heading><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div ng-class=\"cart.monthlyInstallmentsOptions ? \'col-sm-8\' : \'col-sm-7\'\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"nameCard\" placeholder=\"Nombre del tarjetahabiente\" ng-required=\"cart.paymentType == \'card\'\" ng-model=\"vm.cardData.name\"></div></div><div class=\"col-sm-4\" ng-if=\"cart.monthlyInstallmentsOptions\"><div class=\"form-group\"><select class=\"form-control m-b\" ng-model=\"cart.monthlyInstallments\"><option value=\"\" disabled=\"\" selected=\"\">- Meses sin intereses -</option><option value=\"{{option.label}}\" ng-disabled=\"option.minimumPurchase > cart.totalBalance\" ng-repeat=\"option in cart.monthlyInstallmentsOptions\">{{option.label}} MSI (minimo de compra {{option.minimumPurchase | currency}})</option></select></div></div><div ng-class=\"cart.monthlyInstallmentsOptions ? \'col-sm-4\' : \'col-sm-5\'\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"Number\" placeholder=\"Número de tarjeta\" ng-required=\"cart.paymentType == \'card\'\" ng-model=\"vm.cardData.number\"></div></div><div ng-class=\"cart.monthlyInstallmentsOptions ? \'col-sm-3\' : \'col-sm-4\'\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"Expiry\" placeholder=\"Mes de expiración\" ng-required=\"cart.paymentType == \'card\'\" ng-model=\"vm.cardData.exp_month\"></div></div><div ng-class=\"cart.monthlyInstallmentsOptions ? \'col-sm-3\' : \'col-sm-4\'\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"Expiry\" placeholder=\"Año de expiración\" ng-required=\"cart.paymentType == \'card\'\" ng-model=\"vm.cardData.exp_year\"></div></div><div ng-class=\"cart.monthlyInstallmentsOptions ? \'col-sm-2\' : \'col-sm-4\'\"><div class=\"form-group\"><input type=\"text\" class=\"form-control\" name=\"CVC\" placeholder=\"CVC\" ng-required=\"cart.paymentType == \'card\'\" ng-model=\"vm.cardData.cvc\"></div></div></div></div></div></div></uib-accordion-group><uib-accordion-group><uib-accordion-heading><div class=\"panel-heading\" ng-click=\"vm.selectPayment(\'oxxo\')\"><h4 class=\"panel-title\"><a href=\"\" class=\"accordion-toggle\"><span uib-accordion-header=\"\" ng-class=\"{\'text-muted\': isDisabled}\"><i class=\"fa fa-dot-circle-o text-success pull-left icon-select\" ng-if=\"cart.paymentType == \'oxxo\'\"></i> <i class=\"fa fa-circle-o text-success pull-left icon-select\" ng-if=\"cart.paymentType != \'oxxo\'\"></i> Pago en Oxxo <i class=\"fa fa-money text-warning pull-right\"></i></span></a></h4></div></uib-accordion-heading><div class=\"panel-body\"><div class=\"row\"><div class=\"col-xs-12\"><ol><li>Acude a la tienda OXXO más cercana. <a href=\"https://www.google.com.mx/maps/search/oxxo/\" target=\"_blank\">Encuéntrala aquí</a>.</li><li>Indica en caja que quieres realizar un pago de <strong>OXXOPay</strong>.</li><li>Dicta al cajero el número de referencia de la ficha que enviaremos a tu correo electrónico, para que tecleé directamete en la pantalla de venta.</li><li>Realiza el pago correspondiente con dinero en efectivo.</li><li>Al confirmar tu pago, el cajero te entregará un comprobante impreso.<br><strong>En el podrás verificar que se haya realizado correctamente.</strong><br>Conserva este comprobante de pago.</li></ol></div></div></div></uib-accordion-group></uib-accordion></div></div></div><div class=\"col-xs-12 col-md-5 checkout-items-box\"><h3>Resumen de tu pedido</h3><div class=\"card items-box\"><div ng-repeat=\"item in cart.items\" class=\"card row\"><div class=\"col-md-3 img-cart\" ng-style=\"{\'background-image\': \'url({{item.bannerUrl}})\'}\"></div><div class=\"col-md-6 cart-title\"><h4>{{item.isProduct ? item.name + \" - \" + item.presentation.weight + \" \" + item.presentation.name : item.name}}</h4><p>{{item.isProduct ? \"Productos:\" : \"Servicios:\"}} {{item.presentation.quantity}}</p><p>{{item.isProduct ? \"&nbsp;\" : \"Confirmar cita después de compra\"}}</p></div><div class=\"col-md-3 cart-price\"><h4>{{item.presentation.cost * item.presentation.quantity | currency}}</h4></div></div><div class=\"row\"><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 ticket-text\"><span class=\"ticket-title\">Subtotal</span> <span class=\"pull-right\">{{cart.totalPrice | currency}}</span></div><div class=\"col-xs-12 coupon-discount\" ng-if=\"cart.couponDiscount\"><span class=\"ticket-title\">Descuento</span> <span class=\"pull-right\">-{{cart.couponDiscount | currency}}</span></div><div ng-if=\"cart.productIds.length\"><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 ticket-text\"><span class=\"ticket-title\">Envío</span><div class=\"delivery-select\"><div class=\"radio radio-inline radio-success\" ng-if=\"vm.shipmentOptions\"><input type=\"radio\" id=\"inlineRadio1\" ng-disabled=\"!vm.cityFreeShipping\" ng-model=\"cart.deliveryType\" value=\"validate\" name=\"radioInline\" ng-click=\"vm.updateDeliveryBillAmount(vm.shipmentOptions.zmg)\"> <label for=\"inlineRadio1\" uib-tooltip=\"Solo aplica en los municipios de Zapopan, Guadalajara, Tlaquepaque, Tonalá y Tlajomulco de Zuñiga\" tooltip-placement=\"top\"><span ng-if=\"cart.totalBalance > vm.shipmentOptions.zmg.minimumPurchase\" class=\"pull-right\">Gratis</span> <span ng-if=\"cart.totalBalance <= vm.shipmentOptions.zmg.minimumPurchase\" class=\"pull-right\">{{vm.shipmentOptions.zmg.cost | currency}}</span> A domicilio ZMG <small ng-if=\"vm.shipmentOptions.zmg.active\">(Gratis en compras de más de {{vm.shipmentOptions.zmg.minimumPurchase | currency}} en productos)</small><p class=\"text-muted\"><small>&nbsp;</small></p></label></div><div class=\"radio radio-inline radio-success\" ng-if=\"vm.shipmentOptions\"><input type=\"radio\" id=\"inlineRadio2\" ng-model=\"cart.deliveryType\" value=\"normal\" name=\"radioInline\" ng-click=\"vm.updateDeliveryBillAmount(vm.shipmentOptions.country)\"> <label for=\"inlineRadio2\"><span ng-if=\"cart.totalBalance > vm.shipmentOptions.country.minimumPurchase && vm.shipmentOptions.country.active\" class=\"pull-right\">Gratis</span> <span ng-if=\"cart.totalBalance <= vm.shipmentOptions.country.minimumPurchase && vm.shipmentOptions.country.active\" class=\"pull-right\">{{vm.shipmentOptions.country.cost | currency}}</span> <span ng-if=\"!vm.shipmentOptions.country.active\" class=\"pull-right\">{{vm.shipmentOptions.country.cost | currency}}</span> Envío a domicilio Interior de la República <span ng-if=\"vm.shipmentOptions.country.active\">(Gratis en compras de más de {{vm.shipmentOptions.country.minimumPurchase | currency}} en productos)</span><p class=\"text-muted\"><small>* Estafeta express, entrega estimada de 3 a 5 días hábiles.</small></p></label></div><div class=\"radio radio-inline radio-success\"><input type=\"radio\" id=\"inlineRadio3\" ng-model=\"cart.deliveryType\" value=\"pickup\" name=\"radioInline\" ng-click=\"vm.updateDeliveryBillAmount()\"> <label for=\"inlineRadio3\"><span class=\"pull-right\">Gratis</span> Recoger en tienda</label></div></div></div></div><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12 ticket-text\"><span class=\"ticket-title\">Total</span> <span class=\"pull-right ticket-total\">{{cart.totalBalance + vm.temporalDeliveryAmount | currency}}</span></div></div></div><div class=\"col-xs-12 button-confirm-sale\"><button ng-click=\"vm.confirmSale()\" ng-disabled=\"\" class=\"btn btn-primary pull-right\" type=\"submit\">Concretar compra</button></div></div></form></div>");}]);